import type { Glossary } from "@brookbush/types";

import type { GetStaticProps } from "next";
import { NextSeo } from "next-seo";

import { GlossaryBody, GlossaryHeader } from "./components";
import Container from "~/components/Container";
import type { NextPageWithProps } from "~/types";
import fetcher from "~/utils/fetcher.client";

interface GlossaryPageProps {
	glossaries: { [key: string]: Glossary[] };
}

const GlossaryPage: NextPageWithProps<GlossaryPageProps> = ({ glossaries }) => {
	return (
		<Container>
			<NextSeo title="Glossary Terms" description="Glossary Terms" />
			<div className="grid grid-cols-11 gap-4 lg:gap-8">
				<GlossaryHeader />
				<GlossaryBody glossaries={glossaries} />
			</div>
		</Container>
	);
};

export const getStaticProps: GetStaticProps<
	{},
	{
		glossaries: string[];
	}
> = async () => {
	const glossaries = await fetcher("/glossary");

	return {
		props: {
			glossaries,
			breadcrumbs: [{ name: "Glossary", href: "/glossary" }],
		},
	};
};

export default GlossaryPage;
